import LoadMoreComponent from '../../components/LoadMoreComponent';
import DataTable from '../../components/Datatable';
import { COLUMNS } from './keys';
import { linReg } from '../../lib/reduce';
import { scrollForTable } from '../../components/Datatable/utils';
import { withTranslation } from 'react-i18next';

class Invoices extends LoadMoreComponent {
    constructor(props) {
        super();
        try {
            this.invoices = JSON.parse(props.invoices) ?? [];
        } catch (err) {
            this.invoices = [];
        }
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => {
            if (item.title) return item.title?.toLowerCase().includes(search.toLowerCase());
            return item.page?.toLowerCase().includes(search.toLowerCase());
        });
    }

    render() {
        const { t } = this.props;
        const sortFns = {
            impressions_delta: (array) =>
                array.sort((a, b) => {
                    let a_imp = linReg(a.impressionsL);
                    let b_imp = linReg(b.impressionsL);
                    return a_imp.slope - b_imp.slope;
                }),
            page: (array) =>
                array.sort((a, b) => {
                    const a_title = a.title ?? a.page;
                    const b_title = b.title ?? b.page;
                    return a_title.localeCompare(b_title);
                }),
            age: (array) => array.sort((a, b) => a.age - b.age),
            impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
            clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
            ctr: (array) => array.sort((a, b) => a.ctr - b.ctr),
        };

        return (
            <>
                <DataTable
                    nodes={this.invoices}
                    sortFns={sortFns}
                    header={t('invoices.header')}
                    COLUMNS={COLUMNS(t)}
                    fileName={t('invoices.header')}
                    searchFunction={this.searchFunction}
                    onlyTable
                    hasSort={false}
                    additionalStyles={{
                        Table: `
                                --data-table-library_grid-template-columns : minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(150px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                               ${scrollForTable}
                            `,
                        BaseCell: `font-family: 'Raleway';
                                        font-weight: 500;
                                        font-size: 16px;
                                        line-height: 19px;
                                        padding: 16px 10px;
                                        color: #0D182C;
                                    
                                    
                                        &.underline {
                                            text-decoration: underline;
                                        }
                                        
                                        `,
                    }}
                />
            </>
        );
    }
}
export default withTranslation()(Invoices);
